export default () => ({
  user: null,
  groups: [],
  watchlists: [],
  emailAlerts: [],
  trackedBacktests: [],
  insiderAlerts: [],
  whaleAlerts: [],
  limit: 5,
  isTeamMember: false,
  isSubscriber: false,
  isProSubscriber: false,
  isEnterpriseSubscriber: false,
  tradingModels: [],
  sharedModels:[],
  tradingModelSummaries:[],
  screens:[],
  socket_consumer: null,
  socket_channel: null,
  socket_callback: null,
  trading_model_update: null,
  screen_update: null,
  status_update_snackbar: false,
  active_stocks:[],
  active_filers:[],
  trending_stocks:[],
  trending_filers:[],

})
